export default function getStyle() {
  return {
    progress: {
      border: 'solid 1px #ffffff'
    }
  };
};